import { useWorkspacesLocalStore } from '@/store/workspacesLocalStore'
import {
  assertWorkspaceCap,
  assertWorkspaceNameAvailable,
} from '@/services/workspaces/workspaceValidation'

function newWorkspaceId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `local-ws-${Date.now()}`
}

export function listLocalWorkspaces(userId) {
  return useWorkspacesLocalStore.getState().listForUser(userId)
}

export function createLocalWorkspace(userId, payload = {}) {
  const store = useWorkspacesLocalStore.getState()
  const existing = store.listForUser(userId)
  assertWorkspaceCap(existing)
  assertWorkspaceNameAvailable(existing, payload.name)
  const workspace = {
    id: newWorkspaceId(),
    name: String(payload.name || '').trim(),
    icon: payload.icon || payload.emoji || 'briefcase',
    emoji: payload.emoji || null,
    accent: payload.accent || 'slate',
    description: payload.description ?? null,
    createdAt: new Date().toISOString(),
  }
  store.addForUser(userId, workspace)
  return workspace
}
